import './themes/rte-theme.css';

type DisplayRTEDataProps = {
  readonly html: string;
};

export const DisplayRTEData = ({ html }: DisplayRTEDataProps) => (
  <div
    className="border border-border-secondary bg-surface-secondary px-2 py-4"
    dangerouslySetInnerHTML={{ __html: html }}
  />
);
DisplayRTEData.displayName = 'DisplayRTEData';
